import Section from '../ui/Section';
import styles from './Outreach.module.css';

export default function Outreach() {
  return (
    <Section id="community" eyebrow="Community Outreach" title="Rooted in the community.">
      <p>
        Brian has been an integral part of the North Carolina and Virginia community for decades,
        collaborating with local organizations and leading outreach projects across the region.
      </p>
      <div className={styles.banner}>
        <img
          src="/brandbanner.png"
          alt="K97.5, Beat Boyz, The B Spot TV, and BMMC"
          className={styles.bannerImg}
        />
      </div>
    </Section>
  );
}
